// extracted by mini-css-extract-plugin
export var columnList = "_cp-0";